import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"
import App from "../components/appStartkit";
import { Breadcrumb } from "../components/globals/breadcrumb";


const IndexPage = () => (
  <Layout2>
            <Breadcrumb category={["nyheter", "nyheter"]}  page={["Recension Dentway", "dentway-blogg"]}/>  
     <SEO title="Recension Dentway" description="Blogginlägg Dentway"/>
     <section className="section-metoder">
     <main>
       <h1 class="welcome">Gästblogg från Erika</h1>
       <p class="text-center">Gästbloggare som prövade att bleka tänderna hemma.
Vi har låtit 25-åriga Erika testa Dentways Startkit och bloggat om det.</p>
<p class="text-center">
Jag tycker det är riktigt roligt att skriva ett blogginlägg för vitatänder.nu. När jag blev tillfrågad om att medverka och testa en tandblekning från Dentway blev jag riktigt glad.
Jag har faktiskt blekt tänderna innan när jag var 20 och då jag fick ett presentkort i födelsedagspresent. 
Då var det på en klinik i Stockholm för 3500 kr och jag skulle komma tillbaka två gånger. 
Först för att gjuta en skena och sedan bli strålad med en bleklampa.</p>
<p class="text-center">
Däremot när det gick upp för mig att det lilla paketet från Dentway som kom på posten kunde användas i sängen 
var den första tanken: Perfekt. Efter första kvällen så vände o vred jag i spegeln men märkte ingen skillnad. 
Kväll två fortsatter med mungymnastik mot ljuset för att se något. Och visst hade det börjat hända nåt, första resultatet 
hade nu ändrat nyansen mot det vita och bollen var satt i rullning. Tandblekningskrämen smakade mint vilket inte var allt för 
taskigt och skenorna satt bra i munnen.</p>
<p class="text-center">
Totalt blekte jag åtta gånger innan jag blev helt nöjd
Jag lyckades bli av med det gula men vill samtidigt inte har det för vitt och dessutom fick jag över en del.  
Egentligen borde man sluta dricka kaffe för att det ska bli helt enligt anvisningarna, men de som känner mig vet att 
jag inte startar dagen utan kaffe. That’s it. Dessutom har jag druckit ett par koppar genom dagarna och så några hit 
eller dit kan inte skada..</p>

<h3 class="text-center">Ett lyckat resultat med Dentway.</h3>
<p class="text-center">
Det var helt klart enklare, mer bekvämt och minst lika vitt som att gå till tandläkaren som att bli av med 
missfärgningarna hemma. Hos tandläkarenvar jag dessutom tvungen att springa tillbaka ytterligare en gång för att en 
återuppföljning. Visserligen något bra, men inte inte helt nödvändigt om man ofta besöker tandläkaren ändå. 
Vissa personer är riktigt rädda och klarar inte ens av miljön tandläkare vistas i. </p>
<a href="/dentway">Läs vita tänders recension här</a>

       </main>
     </section>
     <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Startkit</h2>
     <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
    <App />
    </main>
  </section>

  </Layout2>
)

export default IndexPage
